import type {CompareMethod} from '@src/constants/compare.ts';
import type {StateSlice, CompareState} from '@src/stores/types.ts';
import type {
  CompareSubject,
  CompareValue,
  SubjectIndex,
} from '@src/types/compare.ts';
import {COMPARE_METHODS} from '@src/constants/compare.ts';
import {UI_MODES} from '@src/constants/map.ts';

export const COMPARE_MODE_DEFAULT_VALUES: Record<CompareMethod, CompareValue> =
  {
    [COMPARE_METHODS.SLIDER]: 0.5,
    [COMPARE_METHODS.FADE]: 0,
    [COMPARE_METHODS.DIFF]: [0.2, 1],
  };

export const initialState = {
  method: COMPARE_METHODS.SLIDER,
  subjects: {
    0: null,
    1: null,
  },
  values: COMPARE_MODE_DEFAULT_VALUES,
};

export const setCompareSlice: StateSlice<CompareState> = set => ({
  ...initialState,
  setCompareSubject: ({
    index,
    subject,
  }: {
    index: SubjectIndex;
    subject: CompareSubject | null;
  }) =>
    set(
      state => {
        state.compare.subjects[index] = subject;
      },
      undefined,
      'compare/setCompareSubject',
    ),
  swapCompareSubjects: () =>
    set(
      state => {
        state.compare.subjects = {
          0: state.compare.subjects[1],
          1: state.compare.subjects[0],
        };
      },
      undefined,
      'compare/swapCompareSubjects',
    ),
  setCompareMethod: (method: CompareMethod) =>
    set(
      state => {
        state.compare.method = method;
      },
      undefined,
      'compare/setCompareMethod',
    ),
  setCompareMethodValue: (method: CompareMethod, value: CompareValue) =>
    set(
      state => {
        state.compare.values[method] = value;
      },
      undefined,
      'compare/setCompareMethodValue',
    ),
  resetCompareSubjects: () =>
    set(
      state => {
        state.compare.subjects = initialState.subjects;
      },
      undefined,
      'compare/resetCompareSubjects',
    ),
  reset: () =>
    set(
      state => {
        state.compare.subjects = initialState.subjects;
        state.compare.method = initialState.method;
        state.compare.values = initialState.values;
        state.map.uiMode = UI_MODES.NONE;
      },
      undefined,
      'compare/resetCompareSubjects',
    ),
});
